export default __webpack_public_path__ + "static/media/Tools-P5-CIFOR.87b2923e.jpg";